import { apiObtengaDatosPersona } from "../Utils/constantes";
import { PersonaFisica } from "../Contenedores/PersonaFisica";
import Http from "./Http";

export async function ObtengaDatosPersona() {
  const salida = new PersonaFisica();
  const url = apiObtengaDatosPersona;

  const respuesta = await Http.get(url);
  salida.Identificacion = respuesta.data.identificacion;
  salida.Nombre = respuesta.data.nombrePublicacion;

  return salida;
}

export default {
  ObtengaDatosPersona,
};
